<template>
  <el-dialog
    title="从电子名片选择一个人员"
    :visible.sync="visible"
    width="720px"
    append-to-body=""
    @closed="handleClosed">
    <div class="search-form">
      <el-input
        v-model="config.name"
        placeholder="请输入姓名"
        style="width: 200px"
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </div>
    <el-table
      v-loading="loading"
      border
      highlight-current-row
      :data="list"
      @current-change="handleCurrentRowChange">
      <el-table-column
        label=""
        width="50">
        <template slot-scope="{row}">
          <el-radio
            v-model="current.nameCardId"
            :label="row.nameCardId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column
        label="姓名"
        width="100"
        prop="name">
      </el-table-column>
      <el-table-column
        label="手机号"
        prop="mobilePhone">
      </el-table-column>
      <el-table-column
        label="邮箱"
        prop="email">
      </el-table-column>
      <el-table-column
        label="部门"
        prop="department">
      </el-table-column>
      <el-table-column
        label="职位"
        prop="position">
      </el-table-column>
    </el-table>
    <el-pagination
      background
      style="text-align: center;"
      :current-page="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="totalNum"
      @current-change="handleCurrentChange">
    </el-pagination>
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        @click="add">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'UserSelectModal',
  components: {},
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      list: [],
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        name: ''
      },
      totalNum: 0,
      current: {}
    }
  },
  watch: {
    current: {
      handler(val) {
        console.log(val)
      },
      deep: true
    }
  },
  created() { },
  mounted() { },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.current = {}
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    add() {
      if (!this.current.nameCardId) {
        this.$message.error('请选择一个人员')
        return
      }
      this.callback && this.callback(this.current)
      this.toggleModal(false)
    },
    handleCurrentRowChange(row) {
      console.log('handleCurrentRowChange', row)
      this.current = row || {}
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('account/getnamecards', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch() {
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
